import { useJobStore } from '../job/useJobStore';
import { useJobApplicationStore } from './useJobApplicationStore';

export const acceptJobApplicationEffect = async (
  jobId: string,
): Promise<void> => {
  try {
    // Refresh the job to get its new state.
    const jobStore = useJobStore.getState();
    await jobStore.fetchJobById(jobId);

    // Refresh job applications for this job.
    const jobApplicationStore = useJobApplicationStore.getState();
    await jobApplicationStore.fetchJobApplicationsForJob(jobId);
  } catch (error) {
    console.error('Error in acceptJobApplicationEffect: ', error);
  }
};
